import { useTranslation } from "react-i18next";
import Text from "./Text";
import Skeleton from "@ingka/skeleton";
import "@ingka/skeleton/dist/style.css";
import styles from "../../assets/scss/components/content/infoBox.module.scss";

export default function InfoBox({ title, subtitle, text, loading = false }) {
  const [t] = useTranslation("global");
  if (loading) {
    return (
      <div>
        <Text tagName="h3" headingSize="s" className={styles.infoBoxLoadingTitle}>
          {t("dashboard.loadingAIsummary")}
        </Text>
        <Skeleton className={styles.infoBoxSkeleton} height="120px" />
      </div>
    );
  }

  return (
    <div className={styles.infoBox}>
      <Text tagName="h3" headingSize="m" className={styles.infoBoxTitle}>
        {title}
      </Text>
      {subtitle && (
        <Text tagName="p" bodySize="m" className={styles.infoBoxSubtitle}>
          {subtitle}
        </Text>
      )}
      <Text tagName="p" bodySize="m">
        {text}
      </Text>
    </div>
  );
}
